
import Vue from "vue";
import {ICustomGroup} from "@/models/dossier-configs/cashier";
import AppColorPicker from "@/components/ColorPicker.vue";

export default Vue.extend({
	data() {
		return {
			pickerKey: 0
		};
	},
	props: {
		value: {
			type: Object as () => ICustomGroup,
			required: true
		},
		isNew: Boolean
	},
	methods: {
		clearColor() {
			this.value.Color = "";
			this.pickerKey++;
		}
	},
	components: {
		AppColorPicker
	},
	i18nEx: {
		componentPrefix: "components.sales.Cashier"
	},
});
